import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("admin_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const DOCTOR = {
  name: "Dr. Jasmine Porwal",
  specialty: "Medical Oncologist",
  qualifications: [
    "DM (Medical Oncology) — AIIMS",
    "MD (Internal Medicine) — PGIMER",
  ],
  tagline: "Evidence-based oncology, delivered with time, honesty, and care.",
};
